import { render, staticRenderFns } from "./GetElderly.vue?vue&type=template&id=45c1fbb9&scoped=true&"
import script from "./GetElderly.vue?vue&type=script&lang=js&"
export * from "./GetElderly.vue?vue&type=script&lang=js&"
import style0 from "./GetElderly.vue?vue&type=style&index=0&id=45c1fbb9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c1fbb9",
  null
  
)

export default component.exports